import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-4 py-12 text-center text-white/65" data-id="element-92" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl" data-id="element-93" data-mp="3ggar7wn6mf5z">
        <p className="font-serif text-2xl text-white" data-id="element-94" data-mp="3ghc4m7ro7dqv">Energy Healing System™</p>
        <p className="mt-3 text-sm font-semibold text-white/80" data-id="element-95" data-mp="32pfgeet4hnzr">
          The #1 self-guided energy healing reference library.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-96" data-mp="3uf0lz5mj42r6">
          Because a professional spiritual practice deserves a real professional system.
        </p>
        <p className="mt-6 text-sm" data-id="element-97" data-mp="387ddgpep1cm">
          📧{' '}
          <a className="transition-colors hover:text-amber" href="mailto:support@eurekalabs.com" data-id="element-98" data-mp="3levgx24t5gg6">
            support@eurekalabs.com
          </a>{' '}
          <span className="mx-2 text-white/30" data-id="element-99" data-mp="3qblwzpgm4c1l">·</span> 🌐 www.eurekalabs.store
        </p>
        <p className="mt-6 text-xs" data-id="element-100" data-mp="29xm06nd2d2ik">© Energy Healing System™ 2026 — All rights reserved.</p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-101" data-mp="2ez1k2c3i92zd">
          This product is a digital download for educational reference purposes only. Results may
          vary. This system does not replace professional medical, psychological, or spiritual
          advice. All content is protected by copyright.
        </p>
      </div>
    </footer>;
}